import { useState } from "react";
import { common_utils } from "../../../../../common/common_utils";
import { Constants } from "../../../../../common/constants";
import { RevertDescriptor } from "../../dashboard_utils";
import { EventCreationInputKeys } from "../../event_creation";
import { GuildSettingsFormStateKeys } from "../../guild_settings/guild_settings";
import { PollCreationInputKeys } from "../../poll_creation";
import { ColorPickerForm } from "../color_picker";
import { SeshAccordianComponent } from "../improved_components/sesh_accordian_component";

export default function ColorPickerAccordian(props: {
	field_key: Extract<
		| EventCreationInputKeys
		| PollCreationInputKeys
		| GuildSettingsFormStateKeys,
		"color" | "default_poll_embed_color" | "default_event_embed_color"
	>;
	is_premium: boolean;
	color: string;
	disabled?: boolean;
	unsaved_changes?: boolean;
	is_channel_override_active?: boolean;
	info: string;
	label: string;
	updateFunc: (value: string) => void;

	revert_descriptor?: RevertDescriptor<string>;
	is_new?: boolean;
}) {
	const current_default = props.revert_descriptor?.default?.value;

	return (
		<SeshAccordianComponent
			label={props.label}
			is_opened={props.color != undefined}
			onChange={(val) =>
				props.updateFunc(
					val ? current_default ?? Constants.EMBED_COLOR : null
				)
			}
			is_new={props.is_new}
			info={props.info}
			disabled={props.disabled}
			is_unsaved={props.unsaved_changes}
			is_channel_override_active={props.is_channel_override_active}
			revert_descriptor={props.revert_descriptor}
		>
			<ColorPickerForm
				updateFunc={(val) => props.updateFunc(val)}
				value={props.color}
			></ColorPickerForm>
		</SeshAccordianComponent>
	);
}
